import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../tokens/api.token';

@Injectable({
  providedIn: 'root',
})
export class CloudBackupService {
  private baseApiUrl = inject(API_URL, { optional: true }) ?? 'https://api.suitelifetools.com';
  private apiUrl = `${this.baseApiUrl}/budgeting`;

  constructor(private http: HttpClient) {}

  // Push local IndexedDB state up to the secure cloud endpoint
  saveBackup(googleSub: string, localData: any, clientTimestamp?: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/backup`, {
      sub: googleSub,
      data: localData,
      clientTimestamp: clientTimestamp,
    });
  }

  // Pull cloud backup state down to the device
  getBackup(googleSub: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/backup/${googleSub}`);
  }

  // Delete cloud backup data from the server
  deleteBackup(googleSub: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/backup/${googleSub}`);
  }
}
